import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import { useEffect, useRef, useState } from "react";

export function CustomCarousel({ data, loading }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoplay, setAutoplay] = useState(true);
  const intervalRef = useRef(null);

  const dir = "rtl"; // or detect dynamically
  const translateSign = dir === "rtl" ? 1 : -1;

  useEffect(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (autoplay && data.length > 1) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % data.length);
      }, 5000);
    }
    return () => clearInterval(intervalRef.current);
  }, [autoplay, data.length]);

  const goToIndex = (idx) => {
    setAutoplay(false);
    setCurrentIndex(idx);
  };
  const handlePrev = () =>
    goToIndex((currentIndex - 1 + data.length) % data.length);
  const handleNext = () => goToIndex((currentIndex + 1) % data.length);

  if (!data.length) return null;

  return (
    <section
      dir={dir}
      className="relative overflow-hidden animate-fadeIn px-10"
    >
      <div className="relative">
        <div className="overflow-hidden border rounded-xl">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{
              transform: `translateX(${translateSign * currentIndex * 100}%)`,
            }}
          >
            {data.map((item) => {
              const reviewer = item.reviewer || {};
              const rating = item.rate || 0;

              return (
                <div key={item.id} className="w-full flex-shrink-0 px-4 md:px-8">
                  <div className="salon-card p-6 md:p-8 shadow-salon">
                    <div className="flex flex-col md:flex-row md:items-center mb-6">
                      <img
                        src={
                          reviewer.image ||
                          "https://ui-avatars.com/api/?name=" +
                            encodeURIComponent(reviewer.name || "طالب")
                        }
                        alt={reviewer.name || "طالب"}
                        className="object-cover w-12 h-12 md:w-16 md:h-16 rounded-full"
                      />
                      <div
                        className={`${
                          dir === "rtl" ? "text-right" : "text-left"
                        } mt-4 md:mt-0 md:mx-4`}
                      >
                        <h3 className="font-bold text-lg">
                          {reviewer.name || "طالب"}
                        </h3>
                        <p className="text-muted-foreground text-sm">
                          {reviewer.role === "student" ? "طالب" : reviewer.role}
                        </p>
                        <div
                          className={`flex justify-start text-secondary mt-1`}
                        >
                          {[...Array(5)].map((_, i) => (
                            <Star
                              key={i}
                              className="w-4 h-4"
                              fill={i < rating ? "#facc15" : "none"}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="relative">
                      <div className="absolute -top-2 -left-2 text-5xl text-primary opacity-20">
                        “
                      </div>
                      <blockquote
                        className={`text-muted-foreground italic relative z-10 text-center ${
                          dir === "rtl" ? "pr-4 pl-0" : ""
                        }`}
                      >
                        {item.message}
                      </blockquote>
                      <div className="absolute -bottom-4 -right-2 text-5xl text-primary opacity-20">
                        ”
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Prev */}
        <button
          onClick={handlePrev}
          aria-label="Previous testimonial"
          className={`absolute top-1/2 -translate-y-1/2 rounded-full p-2 shadow-md bg-blue-600 hover:bg-blue-600/80 text-white transition-colors ${
            dir === "rtl" ? "right-0 translate-x-4" : "left-0 -translate-x-4"
          }`}
        >
          <ChevronLeft className="w-5 h-5" />
        </button>

        {/* Next */}
        <button
          onClick={handleNext}
          aria-label="Next testimonial"
          className={`absolute top-1/2 -translate-y-1/2 rounded-full p-2 shadow-md bg-blue-600 hover:bg-blue-600/80 text-white transition-colors ${
            dir === "rtl" ? "left-0 -translate-x-4" : "right-0 translate-x-4"
          }`}
        >
          <ChevronRight className="w-5 h-5" />
        </button>

        {/* Indicators */}
        <div className="flex justify-center my-6 gap-2">
          {data.map((_, idx) => (
            <button
              key={idx}
              onClick={() => goToIndex(idx)}
              className={`w-3 h-3 rounded-full transition-colors border ${
                idx === currentIndex ? "bg-blue-600" : "bg-muted"
              }`}
              aria-label={`Go to testimonial ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

